module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/8ft-45ae881ec66ce973e55f0710662b83b8.png";